"use client";

import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ServicesUrgence() {
  return <section className="relative w-full h-[400px] overflow-hidden">
      {}
      <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover opacity-40">
        <source src="/videos/technician_at_work.mp4" type="video/mp4" />
      </video>

      {}
      <div className="absolute inset-0 bg-dark-background/60 backdrop-blur-[2px]" />

      {}
      <div className="relative z-10 h-full flex items-center justify-center px-4">
        <div className="text-center space-y-6">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white drop-shadow-strong">
            Besoin d'une intervention rapide ?
          </h2>
          
          <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto drop-shadow-medium">
            Nos artisans sont disponibles 24h/24 pour tous vos travaux urgents
          </p>

          <Link to="/EnUrgencePage">
            <Button size="lg" className="bg-secondary hover:bg-secondary-hover text-foreground-secondary font-semibold text-lg px-8 py-6 rounded-lg shadow-strong hover:shadow-[0_12px_40px_rgb(0_0_0_/_0.2)] transition-all duration-[var(--duration-medium)] hover:scale-105 active:scale-100 animate-pulse hover:animate-none group">
              <Phone className="group-hover:rotate-12 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)]" />
              Appeler maintenant
            </Button>
          </Link>

          <p className="text-white/80 text-sm mt-4">+33 6 32 41 41 20</p>
        </div>
      </div>
    </section>;
}